'use client';

import { Box, Skeleton } from '@mantine/core';
import { useMediaQuery } from '@mantine/hooks';
import 'swiper/css';

const ProductCardSkeleton = () => {
  const isDesktop = useMediaQuery('(min-width: 1120px)');
  const isMobile = useMediaQuery('(max-width: 520px)');

  const getArrayLength = () => {
    if (isDesktop) {
      return 5;
    }
    if (isMobile) {
      return 2;
    }
    return 4;
  };

  const getColmn = () => {
    if (isDesktop) {
      return 'grid-cols-5';
    }
    if (isMobile) {
      return 'grid-cols-2';
    }
    return 'grid-cols-4';
  };

  return (
    <div className={`grid gap-4 ${getColmn()}`}>
      {Array(getArrayLength())
        .fill(0)
        .map((_, index) => (
          <Box
            key={index}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <Box
              style={{
                width: '100%',
                height: '18rem',
              }}
              className="product-card-box"
            >
              <Skeleton height={'100%'} width={'100%'} animate={true} />
              <Skeleton height={12} width={'50%'} animate={true} className="category-skeleton" />
              <Skeleton height={40} animate={true} className="title-skeleton" />
              <Skeleton height={12} width={'70%'} animate={true} className="price-skeleton" />
            </Box>
          </Box>
        ))}
    </div>
  );
};

export default ProductCardSkeleton;
